import { render, staticRenderFns } from "./CattleListItemCard.vue?vue&type=template&id=046c2b38&scoped=true&"
import script from "./CattleListItemCard.vue?vue&type=script&lang=js&"
export * from "./CattleListItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CattleListItemCard.vue?vue&type=style&index=0&id=046c2b38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c2b38",
  null
  
)

export default component.exports